import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { NativeInteractiveElementnutmif7l5rxf as NativeInteractiveElement } from '../InteractiveElement.commonHtml.mjs';
import { vpropka48um9uweps as vprop } from './helpers.commonHtml.mjs';
import {
  switchDriverValuer8prxjgoi83j as switchDriverValue,
  switchDriverActionsjmoklmnalzmn as switchDriverActions,
} from './DriverOverrides.mjs';
import { plus2m1vv33moko5t as plus } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Maps.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function Switch$checked$lambda($this$vprop) {
  // Inline function 'com.lightningkite.kiteui.views.checked' call
  var tmp = $this$vprop.attributes_1.native_1.checked;
  return ((!(tmp == null) ? typeof tmp === 'boolean' : false) ? tmp : null) === true;
}
function Switch$checked$lambda_0($this$vprop, value) {
  // Inline function 'com.lightningkite.kiteui.views.checked' call
  $this$vprop.attributes_1.native_1.checked = value;
  return Unit_instance;
}
var SwitchClass;
function Switch() {
  if (SwitchClass === VOID) {
    class $ extends NativeInteractiveElement() {
      constructor(context) {
        super(context);
        this.native_1.tag_1 = 'input';
        var tmp0 = this.native_1.attributes_1;
        // Inline function 'com.lightningkite.kiteui.views.type' call
        var value = 'checkbox';
        tmp0.native_1.type = value;
        this.native_1.setAttribute_j9pxft_k$('role', 'switch');
        this.native_1.classes_1.add_utx5q5_k$('switch');
        this.native_1.classes_1.add_utx5q5_k$('checkResponsive');
        var tmp = this;
        var tmp_0 = this.native_1;
        var tmp_1 = Switch$checked$lambda;
        tmp.checked_1 = vprop(tmp_0, 'input', tmp_1, Switch$checked$lambda_0);
      }
      get_driverValue_yh5neo_k$() {
        return switchDriverValue(this);
      }
      get_driverActions_8jqr2k_k$() {
        return plus(super.get_driverActions_8jqr2k_k$(), switchDriverActions(this));
      }
    }
    initMetadataForClass($, 'Switch');
    SwitchClass = $;
  }
  return SwitchClass;
}
//region block: exports
export {
  Switch as Switchrdgqp2jwylc6,
};
//endregion

//# sourceMappingURL=Switch.commonHtml.mjs.map
